<mat-card style="padding: 0px;">
  <nav class="product-tabs" aria-label="Produtos SRM, SRP, PSRM e PSC">
      <a
        class="product-tab"
        [routerLink]="['/srm/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        SRM
      </a>
      <a
        class="product-tab active"
        aria-current="page"
        [routerLink]="['/srp/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        SRP
      </a>
      <a
        class="product-tab"
        [routerLink]="['/spr/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        PSRM
      </a>
      <a
        class="product-tab"
        [routerLink]="['/spc/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        PSC
      </a>
    </nav>

  <mat-card-header>
  <mat-card-title>Seca Relativa Predominante</mat-card-title>
  </mat-card-header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <mat-divider></mat-divider>

  <mat-card-content>
    

    <div class="selector-layout">
      <div class="selector">
        <mat-form-field>
          <mat-label>Filtrar por Estado</mat-label>
          <mat-select [value]="ufSelecionada" (selectionChange)="navegarParaUf($event.value)">
            <mat-option value="BR">Brasil - BR</mat-option>
            <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">
              {{ uf.nome }} - {{ uf.sigla }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Mês/Ano</mat-label>
          <mat-select [disabled]="loading || !datas.length" [(value)]="dataSelecionada" (selectionChange)="onDataChange()">
            <mat-option *ngFor="let data of datas" [value]="data">
              {{ data }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-card class="description-card">
        <mat-card-content>
          <p>
            A <b>Seca Relativa Predominante (SRP)</b> representa, para cada município e em cada mês de referência, a condição de seca que predomina em seu território, ocupando o maior percentual de sua área. Diferentemente da Seca Relativa Máxima (SRM), que considera a maior intensidade registrada, a SRP identifica, considerando as cores da legenda do Mapa do Monitor, a categoria de seca com maior abrangência espacial no município, incluindo a classificação de sem seca relativa (SSR). A SRP não considera a continuidade temporal do fenômeno, configurando-se exclusivamente como um retrato espacial da condição de seca predominante naquele mês. Para verificar se a seca é de curto (C), longo (L) ou curto e longo prazo (CL), consulte o Mapa do Monitor na página principal.
          </p>
        </mat-card-content>
      </mat-card>
    </div>

  <div class="cards-row">
    <mat-card class="card card--small">
      <mat-card-title>País</mat-card-title>
      <div class="ufs">
        <!-- países -->
        <a
          class="uf-chip"
          *ngFor="let p of paises"
          [routerLink]="['/srp/municipio', p.sigla]"
          [queryParams]="currentQueryParams"
          [class.active]="ufSelecionada === p.sigla"
        >
          {{ p.sigla }}
        </a>
      </div>
    </mat-card>

    <mat-card class="card">
      <mat-card-title>Estados (UF)</mat-card-title>
      <div class="ufs">
        <a
          class="uf-chip"
          *ngFor="let uf of ufs"
          [routerLink]="['/srp/municipio', uf.sigla]"
          [queryParams]="currentQueryParams"
          [class.active]="ufSelecionada === uf.sigla"
        >
          {{ uf.sigla }}
        </a>
      </div>
    </mat-card>
  </div>
  <p class="placeholder" role="status" *ngIf="!loading && !datas.length">
    {{ erroCarregamento ? 'Não foi possível carregar os meses do SRP. Tente novamente.' : 'Ainda não há mapas de SRP disponíveis para consulta.' }}
  </p>
  <button mat-button *ngIf="!loading && !datas.length" (click)="carregarDatas()">Tentar novamente</button>
  <div class="mapas-row" *ngIf="dataSelecionada">
  <app-ms-image [imagemMsUrl]="imagemMsUrl" width="50%"></app-ms-image>
  <app-srm-image [imagemSrmUrl]="imagemSrpUrl" alt="Mapa de Seca Relativa Predominante (SRP)" width="50%"></app-srm-image>

  </div>
  </mat-card-content>
</mat-card>
